import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; 

const CustomCheckbox = ({index, entityCheckboxValue, toggleDropdown, handleCheck, handleCheckSingleEntity})  => {
    return (
        <div style={{ "display": "flex", "flexDirection": "column" }}>
            <div style={{ "display": "flex" }}>
                <input
                    type="checkbox"
                    onChange={(e) => handleCheck(e.target.checked, index)}
                    checked={entityCheckboxValue.checked}
                />
                <div style={{ "display": "flex", width: 'fit-content', cursor: 'pointer' }} onClick={() => toggleDropdown(index)}>
                    <span style={{ 'marginLeft': 5 }}>{entityCheckboxValue.label}
                    </span>
                    <div style={
                        {"width": 10, "height": 10, "backgroundColor": entityCheckboxValue.color ? entityCheckboxValue.color : "red", "marginTop": "7px", "marginLeft": "5px", "borderRadius": "15px"}
                    }>
                        <span style={{position: "relative", "bottom": 7, "left": 15}}>
                            <FontAwesomeIcon icon={entityCheckboxValue.isOpenDropdown ? faCaretUp : faCaretDown} />
                        </span>
                    </div>
                </div>
            </div>
            {
                entityCheckboxValue.isOpenDropdown && (
                    <div style={{"marginLeft": 15}}>
                        {
                            entityCheckboxValue.value.map((singleEntity, singleEntityIndex) => (
                                <div style={{ "display": "flex" }}>
                                <input
                                    type="checkbox"
                                    onChange={(e) => handleCheckSingleEntity(e.target.checked, index, singleEntityIndex)}
                                    checked={singleEntity.checked}
                                />
                                <div style={{ "display": "flex" }}>
                                    <span style={{ 'marginLeft': 5 }}>{singleEntity.lease || singleEntity.station}
                                    </span>
                                </div>
                            </div>
                            ))
                        }
                    </div>
                )
            }
        </div>
    )
}



export default CustomCheckbox